module.exports = __webpack_public_path__ + "img/6.ae0f2067.png";